// ---------------------------------------------------------------------------
// DnD Email Editor V2 – "authored here" marker
//
// The compiler stamps this attribute on the <body> of every email it produces,
// which is how compiled html can be recognised as a DnD document later. Kept in
// its own dependency-free module so pages that only need to *label* a record
// (the templates list) can import it without pulling in the editor.
//
// The record's jsonContent is the real source of truth for "is this a DnD
// record" — see detectEditorType — but the template *list* endpoint returns
// html and never jsonContent, so the marker is all those callers have.
// ---------------------------------------------------------------------------

export const DND_HTML_MARKER = 'data-ftp-editor-mode="dnd"';

/** Whether this html was compiled by the drag-and-drop editor. */
export function isDndHtml(html: string | null | undefined): boolean {
  return !!html && html.includes(DND_HTML_MARKER);
}
